// routes
import React, { useEffect, forwardRef, useRef, useState, createContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useJsApiLoader } from '@react-google-maps/api';
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { encryptStorage, setItemInL } from './CustomStorage';
import { APP_CONSTANTS } from './URLConstants';

export const ThemeContext = createContext(null);

export default function App() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_G_MAP_API_KEY,
    libraries: ['places']
  });

  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};

  useEffect(() => {
    if (encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS) === undefined)
      setItemInL(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);

    if (process.env.NODE_ENV === 'production') {
      console.log = function () {};
    }
  }, []);

  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <ThemeContext.Provider value={isLoaded}>
        <Router />
      </ThemeContext.Provider>
    </ThemeConfig>
  );
}
